import * as React from "react";
import { NearbySuburb } from "./NearbySuburb";
import { CostOfCareCalculatorContext } from "./context/CostOfCareCalculatorState";

export const NearbySuburbsComponent = () => {

    const { state, dispatch } = React.useContext(CostOfCareCalculatorContext)

    const maxPrice = state.nearbySuburbData[0].AverageFee.amount

    const ClosePopover = () => {
        var evt = new CustomEvent("opensuburbpopover", { detail: { name: null } });
        window.dispatchEvent(evt);
    }

    return (
        <React.Fragment>
            <div className="w-full" onMouseLeave={() => ClosePopover()}>
                <div className="text-lg text-skin-heading font-semibold mb-5">Compared to nearby suburbs</div>
                <div className="w-full">
                    
                            {state.nearbySuburbData.map((suburb, index) => {
                                let suburbAverage = suburb.AverageFee.amount % Math.floor(suburb.AverageFee.amount) > 0 ? suburb.AverageFee.amount.toFixed(2) : suburb.AverageFee.amount

                                if (suburb.Name == state.suburbName) {
                                    return <NearbySuburb key={index} suburb={suburb} maxPrice={maxPrice} suburbAverage={suburbAverage} current={true} />
                                } else {
                                    return <NearbySuburb key={index} suburb={suburb} maxPrice={maxPrice} suburbAverage={suburbAverage} current={false} />
                                }
                            })}
                    
                </div>
            </div>
        </React.Fragment>
    );
}